import React, {ReactElement, useContext} from 'react';

import {cx} from '@emotion/css';
import DeviceContext, {Device} from '@fo/shared-providers/DeviceContext';

import {ReactComponent as FundingOptionsBlueLogoOnly} from '@fo/shared-images/logo/FOxTide_blue_circle.svg';
import {ReactComponent as FundingOptionsAndTideBlueLogoWithText} from '@fo/shared-images/logo/FOxTide_logo_blue.svg';

interface Props {
  className?: string;
  hideTideBranding?: boolean;
}

function FundingOptionsLogo({className, hideTideBranding}: Props): ReactElement {
  const {device} = useContext(DeviceContext);
  const isMobile = device === Device.MOBILE;

  if (hideTideBranding) {
    return <FundingOptionsBlueLogoOnly className={cx(className)} />;
  }

  if (isMobile) {
    return <FundingOptionsBlueLogoOnly className={cx(className)} />;
  }

  return <FundingOptionsAndTideBlueLogoWithText className={cx(className)} />;
}

export default FundingOptionsLogo;
